export const environment = {
  prod: true,
  useMockData: false,
  apiUrl: 'https://api.sbkash.com/api',
  // apiUrl: 'https://sbpay-api.bajiexch365.com/api',
  cryptoSecret: 'ASgO-57!,xdFhKjA',
  sentryDSN:
    'https://4d66cdbc691ab3b5918f6b7b90b91108@o4505662875500544.ingest.us.sentry.io/4509824102236160',
};
